import script from "./mainButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainButton.vue?vue&type=script&setup=true&lang=ts"

import "./mainButton.vue?vue&type=style&index=0&id=50a1f613&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a1f613"]])

export default __exports__